import { FC, FormEventHandler, useState, useRef } from 'react';

import { BiLogIn } from 'react-icons/bi';

import { useToast } from '@chakra-ui/react';

import { Container } from './styles';

import { Spinner } from '../Spinner';

interface ILoginContainerProps {
  readonly signin: (password: string) => Promise<void>;
}

export const LoginContainer: FC<ILoginContainerProps> = ({ signin }) => {
  const [loading, setLoading] = useState<boolean>(false);
  const ref = useRef<HTMLInputElement>();

  const toast = useToast({
    position: 'top-right',
    duration: 25000,
  });

  const handleSubmit: FormEventHandler = async (ev) => {
    ev.preventDefault();
    if (!ref.current?.value) {
      toast({
        status: 'warning',
        description: 'Informe a senha de acesso!',
      });

      return;
    }

    setLoading(true);
    const { value } = ref.current;
    await signin(value).finally(() => setLoading(false));
  };

  return (
    <Container onSubmit={handleSubmit}>
      <div>
        <BiLogIn size={60} />
        <h1>Informe a senha de acesso</h1>
      </div>

      <div>
        <input type="password" ref={ref} />
        {loading ? (
          <div id="spinner-container">
            <Spinner size={30} />
          </div>
        ) : (
          <button type="submit">Entrar</button>
        )}
      </div>
    </Container>
  );
};
